import { useCallback } from 'react';

import { useLogoutMutation } from '@/entities/user/api/user.api';
import { AppStorage } from '@/shared/constants/app-storage.constant';
import { redirectToManagedLogout } from '@/shared/lib/keycloak/keycloak-auth';

export const useManagedLogout = () => {
	const [logout, logoutState] = useLogoutMutation();

	const managedLogout = useCallback(async () => {
		try {
			await logout().unwrap();
		} catch {}

		Object.values(AppStorage).forEach((storageKey) => {
			localStorage.removeItem(storageKey);
		});

		redirectToManagedLogout();
	}, [logout]);

	return [managedLogout, logoutState] as const;
};
